import { useState } from "react"

// Required fields and the friendly Ukrainian message shown when each is empty.
const REQUIRED = {
  title: "Вкажи назву книжки",
  author: "Хто автор?",
  genre_id: "Оберіть жанр",
}

// Owns the book form's values, validation and the fetch submission lifecycle
// (idle → submitting → success). `getFile` returns the currently chosen cover
// file (managed outside, by useCoverPreview).
const useBookForm = (config, getFile) => {
  const [values, setValues] = useState({
    title: config.book.title || "",
    author: config.book.author || "",
    genre_id: config.book.genre_id ? String(config.book.genre_id) : "",
  })
  const [errors, setErrors] = useState({})
  const [status, setStatus] = useState("idle") // idle | submitting | success
  const [formError, setFormError] = useState(null)
  const [shake, setShake] = useState(false)

  const triggerShake = () => {
    setShake(true)
    setTimeout(() => setShake(false), 500)
  }

  const change = (name, value) => {
    setValues((v) => ({ ...v, [name]: value }))
    if (errors[name]) setErrors((e) => ({ ...e, [name]: null }))
  }

  const validate = () => {
    const next = {}
    Object.entries(REQUIRED).forEach(([field, message]) => {
      if (!String(values[field]).trim()) next[field] = message
    })
    return next
  }

  const submit = async (e) => {
    e.preventDefault()
    if (status !== "idle") return

    const found = validate()
    if (Object.keys(found).length) {
      setErrors(found)
      triggerShake()
      return
    }

    setStatus("submitting")
    setFormError(null)

    const fd = new FormData()
    fd.append("book[title]", values.title.trim())
    fd.append("book[author]", values.author.trim())
    fd.append("book[genre_id]", values.genre_id)
    const file = getFile()
    if (file) fd.append("book[cover]", file)
    if (config.method === "patch") fd.append("_method", "patch")

    try {
      const res = await fetch(config.action, {
        method: "POST",
        headers: { "X-CSRF-Token": config.csrf, Accept: "application/json" },
        body: fd,
      })
      const data = await res.json().catch(() => ({}))

      if (res.ok && data.ok) {
        setStatus("success")
        setTimeout(() => {
          if (window.Turbo) window.Turbo.visit(data.redirect)
          else window.location.href = data.redirect
        }, 750)
      } else {
        // Map Rails error keys (title/author/genre) back to friendly messages.
        const mapped = {}
        Object.entries(data.errors || {}).forEach(([key, msgs]) => {
          const field = key === "genre" ? "genre_id" : key
          mapped[field] = Array.isArray(msgs) ? msgs[0] : String(msgs)
        })
        setErrors(mapped)
        setStatus("idle")
        triggerShake()
      }
    } catch (err) {
      setFormError("Не вдалося зберегти. Перевір зʼєднання і спробуй ще раз.")
      setStatus("idle")
    }
  }

  return { values, errors, status, formError, shake, change, submit }
}

export default useBookForm
